<!--
 * @Author       : 萝卜兄台
 * @Date         : 2023-03-01 13:34:23
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2023-04-11 14:29:48
 * @FilePath     : \vue3-ts-mm\src\App.vue
 * @Description  : 这是描述
-->

<template>
  <a-config-provider :locale="locale">
    <RouterView v-if="store.isRouterAlive" />
  </a-config-provider>
</template>
<script lang="ts" setup>
import { ref, computed } from 'vue'
import { globalStore } from '@/store/global'
import zh_CN from 'ant-design-vue/es/locale/zh_CN'
import en_US from 'ant-design-vue/es/locale/en_US'
import tr_TR from 'ant-design-vue/es/locale/tr_TR'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

dayjs.locale('zh-cn')


const store: any = globalStore()

const locale = computed(() => {
  // return store.lang // === 'en_US' ? en_US : zh_CN
  if (store.lang === 'en_US') {
    return en_US
  } else if (store.lang === 'tr_TR') {
    return tr_TR
  } if (store.lang === 'zh_CN') {
    return zh_CN
  }
})
</script>
<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
}

.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}

.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
